// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const Reports = reactLazyRetry(() => import('./pages/Reports.v2'));
const AdvanceReport = reactLazyRetry(
  () => import('./pages/AdvanceReports/Main')
);
const ViewAdvanceReport = reactLazyRetry(
  () => import('./pages/AdvanceReports/ViewReport')
);
const ReportCategory = reactLazyRetry(
  () => import('./pages/ReportCategory/Category')
);
const ChartVisualization = reactLazyRetry(
  () => import('./pages/ReportCategory/ChartVisualization')
);
const ReportCanvas = reactLazyRetry(
  () => import('./pages/ReportCanvas/Canvas')
);

/**
 * Legacy Reports (Old Reports / Advance Report) route definitions and
 * metadata used by the application router and permission-aware navigation.
 */
export const oldReportsRoutes = [
  {
    name: 'Reports',
    key: 'report',
    path: DEFAULT_ROUTE_CONFIG?.report?.path || 'report',
    element: <Reports />,
    permission: 'RulesReports_report',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Advance Report',
    key: 'advanceReport',
    path: DEFAULT_ROUTE_CONFIG?.advanceReport?.path || 'advanceReport',
    element: <AdvanceReport />,
    permission: 'RulesReports_advanceReport',
    children: [
      {
        name: 'Report Category',
        key: 'reportCategory',
        path:
          DEFAULT_ROUTE_CONFIG?.reportCategory?.path ||
          'advanceReport/report-category',
        element: <ReportCategory />,
        permission: 'RulesReports_advanceReport',
      },
      {
        name: 'Report Canvas',
        key: 'reportCanvas',
        path:
          DEFAULT_ROUTE_CONFIG?.reportCanvas?.path ||
          'advanceReport/report-canvas',
        element: <ReportCanvas />,
        permission: 'RulesReports_advanceReport',
      },
      {
        name: 'View Report',
        key: 'viewReport',
        path:
          DEFAULT_ROUTE_CONFIG?.viewAdvanceReport?.path ||
          'advanceReport/viewAdvanceReport',
        element: <ViewAdvanceReport />,
        permission: 'RulesReports_advanceReport',
      },
      {
        name: 'Chart Visualization',
        key: 'chartVisualization',
        path: 'advanceReport/chart-visualization',
        element: <ChartVisualization />,
        permission: 'RulesReports_advanceReport',
      },
    ],
  },
];
